import { render, staticRenderFns } from "./RowingVideo.vue?vue&type=template&id=2f5f7842&"
import script from "./RowingVideo.vue?vue&type=script&lang=js&"
export * from "./RowingVideo.vue?vue&type=script&lang=js&"
import style0 from "./RowingVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports